import React from 'react';
import PasswordlessSignUpScreen from '../../src/screens/auth/PasswordlessSignUpScreen';
import { useAuth } from '../../src/context/AuthContext';

export default function SignupRoute() {
  const { refreshAuth } = useAuth();
  return <PasswordlessSignUpScreen onSignUpSuccess={refreshAuth} />;
}
